import { TenantInterface, UserVarsMap } from "@swivl-mono/types";
import { useEffect, useState } from "react";

import LeasesModel from "../../Models/Leases/Leases.Model";
import Pill, { PillSize, PillStyle, PillType } from "../Pill/Pill";
import { DataCardLeases } from "./DataCard.Leases";
import { DataCardLocation } from "./DataCard.Location";
import "./DataCard.scss";

interface TenantCardProps {
  tenant: TenantInterface;
  userVars: UserVarsMap | undefined;
}

export function DataCardTenant(props: TenantCardProps) {
  const { tenant, userVars } = props;
  const { leases } = LeasesModel.useState((s) => s);
  const [filteredLeases, setFilteredLeases] = useState(leases);

  useEffect(() => {
    LeasesModel.getLeasesByUserId(tenant.userId, true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setFilteredLeases(leases?.filter((l) => l.tenantId === tenant.id && l.active === true));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [leases]);

  return (
    <div className="DataCardTenant">
      {userVars && tenant && (
        <DataCardLocation
          title="Tenant"
          locationId={tenant?.locationId}
          pills={[<Pill type={PillType.PURPLE} size={PillSize.SMALL} style={PillStyle.LIGHT} text="Tenant" />]}
          footer={tenant && <DataCardLeases key={tenant.id} leases={filteredLeases} />}
          variant="secondary"
        />
      )}
    </div>
  );
}
